import fetch,{postFrom} from '../utils/fetch';

export function management(params) {
  return fetch({
    method: 'POST',
    url: '/homepage/management',
    data:params
  })
}

export function projectManagement(params) {
  return fetch({
    method: 'GET',
    url: '/homepage/projectManagement',
    params
  })
}
export function renewStatistics(params) {
  return fetch({
    method: 'POST',
    url: '/homepage/renewStatistics',
    data:params
  })
}
export function signTranslation(params) {
  return fetch({
    method: 'POST',
    url: '/homepage/signTranslation',
    data:params
  })
}
// stock 库存
export function stock(params) {
  return fetch({
    method: 'POST',
    url: '/homepage/stockData',
    data:params
  })
}
export function zoAchievement(params) {
  return fetch({
    method: 'POST',
    url: '/homepage/zoAchievement',
    data:params
  })
}
export function lxnTest(params) {
  return fetch({
    method: 'POST',
    url: '/homepage/tableau',
    data:params
  })
}
